import React from "react";

const RightServiceButtonSection2 = (props) => {
  return (
    <button className="mt-7 h-16 w-32 mx-2 cursor-pointer rounded-lg border-2 border-black bg-slate-50  font-medium hover:bg-amber-400  ">
      {props.button}
    </button>
  );
};

export default RightServiceButtonSection2;
